import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { IconButton } from "@mui/material" // Import Grid from MUI
import moment from "moment"
import React from "react"
import { momentLocalizer } from "react-big-calendar"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { CustomButton } from "../GlobalComponents/CommonComponents"
import "./index.css"
const viewList = [
  { view: "month", name: "Month" },
  { view: "week", name: "Week" },
  { view: "day", name: "Day" },
]

function CustomToolbar({ label, onNavigate, onToday, currentView, handleView }) {
  // const handleView = (view) => {
  //     onView(view);
  //     setCalendarView(view);
  // };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      {/* "Today" Button */}

      <div className="center-container">
        <CustomButton
          text="Today"
          onClick={onToday}
          sx={{
            backgroundColor: "#fff",
            color: "#2076e5",
            border: "1px solid #2076e5",
            shadow: "none",
          }}
        />

        <IconButton
          className="icon-styles"
          onClick={() => onNavigate("PREV")}
          sx={{ color: "inherit" }}
        >
          <ChevronLeftIcon sx={{ width: "40px", height: "40px" }} />
        </IconButton>

        <span
          style={{
            marginBottom: "5px",
            minWidth: "180px",
            textAlign: "center",
            fontSize: "20px",
          }}
        >
          {label}
        </span>

        <IconButton
          className="icon-styles"
          onClick={() => onNavigate("NEXT")}
          sx={{ color: "inherit" }}
        >
          <ChevronRightIcon sx={{ width: "40px", height: "40px" }} />
        </IconButton>
      </div>
      <div
        className="custom-toolbar-views"
        style={{ border: "1px solid lightgrey", borderRadius: 4, borderLeftWidth: "2px" }}
      >
        {viewList?.map((item, index) => (
          <button
            key={index}
            className={"toolbar_button_styles"}
            style={{
              borderLeft: item?.view === "month" && 0,
              background: currentView === item?.view ? "#fff" : "#ddd",
            }}
            onClick={() => handleView(item?.view)}
          >
            {item?.name}
          </button>
        ))}
      </div>
    </div>
  )
}

export default CustomToolbar
